import { useQueryClient } from "@tanstack/react-query";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { AppShell } from "~/components/shell/app-shell";
import { meQuery, signOut, useCurrentUser } from "~/lib/auth";

export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ context, location }) => {
    const me = await context.queryClient.ensureQueryData(meQuery);
    if (!me) {
      throw redirect({ to: "/login", search: { redirect: location.href } });
    }
    if (!me.onboarded) throw redirect({ to: "/onboarding/security" });
  },
  component: AppLayout,
});

function AppLayout() {
  const { user, unreviewedLeads } = useCurrentUser();
  const queryClient = useQueryClient();
  return (
    <AppShell
      user={{ name: user.name, email: user.email, role: user.role }}
      onSignOut={() => signOut(queryClient)}
      badges={unreviewedLeads > 0 ? { "/leads": unreviewedLeads } : {}}
    >
      <Outlet />
    </AppShell>
  );
}
